const IMAGE_BASE_URL = 'https://www.secretsfl.com/files'

export type ImageTable = 'events' | 'news' | 'galleries'

export interface ImageUrls {
  source: string
  square: string
  squareThumb: string
  landscape: string
  landscapeThumb: string
  portrait: string
  portraitThumb: string
}

export interface EventImageUrls extends ImageUrls {
  poster: string
}

export function getImageUrls(table: 'events', filename: string): EventImageUrls
export function getImageUrls(table: 'news' | 'galleries', filename: string): ImageUrls
export function getImageUrls(table: ImageTable, filename: string): ImageUrls | EventImageUrls {
  const base: ImageUrls = {
    source: `${IMAGE_BASE_URL}/${table}/${filename}`,
    square: `${IMAGE_BASE_URL}/${table}/square/${filename}`,
    squareThumb: `${IMAGE_BASE_URL}/${table}/square/thumbs/${filename}`,
    landscape: `${IMAGE_BASE_URL}/${table}/landscape/${filename}`,
    landscapeThumb: `${IMAGE_BASE_URL}/${table}/landscape/thumbs/${filename}`,
    portrait: `${IMAGE_BASE_URL}/${table}/portrait/${filename}`,
    portraitThumb: `${IMAGE_BASE_URL}/${table}/portrait/thumbs/${filename}`,
  }

  if (table === 'events') {
    return {
      ...base,
      poster: `${IMAGE_BASE_URL}/events/poster/${filename}`,
    }
  }

  return base
}

export function getEventImageUrls(filename: string): EventImageUrls {
  return getImageUrls('events', filename)
}
